import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  skeletonContainer: {
    borderRadius: 0,
  },
  skeleton: {
    marginBottom: 8,
    height: 66,
    width: '80%',
  },
  skeletonMini: {
    marginBottom: 8,
    height: 44,
    width: '80%',
  },
  agreed: {
    color: theme.palette.success.light,
  },
  notAgreed: {
    color: theme.palette.error.light,
  },
  noDecision: {
    color: theme.palette.badges.orange,
  },
}));

export default useStyles;
